// extracted by mini-css-extract-plugin
module.exports =  {"banks":"a10a3f92e9--banks--XKl6B","bank":"a10a3f92e9--bank--VuYEq","icon":"a10a3f92e9--icon--euAb7"};